import {Dimensions, ScrollView, View} from "react-native";
import {ActivityIndicator, IconButton} from "react-native-paper";
import React, {useContext, useEffect, useState} from 'react'
import {apiIdle, apiRequest} from "@data/redux/actions/api";
import {connect, useSelector} from "react-redux";
import {DimensionsContext} from "@common/utils/mobileUtils";
import {theme} from "@common/theme/theme";
import {useNavigation} from "@react-navigation/native";
import {schoolsService} from "@data/services/schoolsService";
import {whatIsIt} from "@data/utility/Utils";
import TitleM from "@common/components/text/TitleM";
import ServerSearch from "../common/components/input/ServerSearch";
import {HeaderContainerM} from "@common/header/HeaderContainerM";
import SchoolStudentsTable from "./SchoolStudentsTable";
import {IconImageM} from "@common/components/icons/IconsM";
import {SelectInputM} from "../student/account/onboarding/SelectInputM";
import moment from "moment";
import {weekDaysObject} from "@data/constants/activitiesConstants";
import {StatisticsItem} from "@common/components/statistics/StatisticsItem";
import mealsImage from "@assets/icons/generic/lunch-bag.png";
import treesImage from "@assets/icons/generic/tree.png";
import starRating from "@assets/icons/generic/star-rating.png";
import live from "@assets/icons/generic/live.png";
import student from "@assets/avatar/default/student.png";
import checked from "@assets/icons/generic/checked.png";

function SchoolStatisticsHeader({school, statsPeriod}) {

    // console.log("school", school)

    const request = useSelector((state) => state.api[schoolsService.getSchool.name]?.request) ?? false

    return <View style={{
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        paddingTop: 0,
        marginBottom: -10,
        justifyContent: "center",
        width: Dimensions.get("window").width,
        backgroundColor: theme.colors.whiteAlmost
    }}>
        <StatisticsItem source={student}
                        color={theme.colors.primary}
                        title={"élèves actifs"}
                        count={school?.statistics?.[statsPeriod]?.active_students ?? "-"}
                        totalCount={"/"+(school?.statistics?.[statsPeriod]?.total_students ?? "-")}
                        style={{width: null}}
        />
        <StatisticsItem source={checked}
                        color={theme.colors.success}
                        title={"présence en live"}
                        count={school?.statistics?.[statsPeriod]?.engagement?.total_live_reports ? Math.round(school?.statistics?.[statsPeriod]?.engagement?.live_reports * 100 / school?.statistics?.[statsPeriod]?.engagement?.total_live_reports) : "-"}
                        totalCount={"%" ?? "-"}
                        style={{width: null}}
        />
        <StatisticsItem source={live}
                        color={theme.colors.primary}
                        title={"performance en live"}
                        count={school?.statistics?.[statsPeriod]?.engagement?.scores?.total?.result ?? "-"}
                        totalCount={"/"+100}
                        style={{width: null}}
        />
        <StatisticsItem source={starRating}
                        color={theme.colors.accentDark}
                        title={"satisfaction élève"}
                        count={school?.statistics?.[statsPeriod]?.engagement?.live_satisfaction_average ?? "-"}
                        totalCount={"/"+5}
                        style={{width: null}}
        />
        <StatisticsItem source={mealsImage}
                        color={theme.colors.petalNew}
                        title={"repas offerts"}
                        count={school?.statistics?.[statsPeriod]?.engagement?.meals_offered_count ?? "-"}
                        style={{width: null}}
        />
        <StatisticsItem source={treesImage}
                        color={theme.colors.petal}
                        title={"arbres plantés"}
                        count={school?.statistics?.[statsPeriod]?.engagement?.trees_planted_count ?? "-"}
                        style={{width: null}}
        />
        {request &&
            <ActivityIndicator color={theme.colors.primary} style={{position: "absolute", left: 50, marginBottom: 10}}
                               size={10}/>}
    </View>
}

const SchoolScreen = (props) => {

    const {route} = props
    const {
        search,
        schoolId = null,
        anonymous = false
    } = route.params || {};

    const anon = anonymous === "true" || anonymous === true

    const currentUrlRouteParams = {
        search,
        anonymous: anon,
        sort_by: "manual_sub_ends_at",
        order: "desc"
    }
    const navigation = useNavigation()

    const school = props.schools?.find(s => s.id === parseInt(schoolId))

    const requestApiService = schoolsService.searchUser

    useEffect(() => {
        props.apiRequest(schoolsService.getSchool, {id: schoolId})
    }, [])

    const formValues = Object?.keys(currentUrlRouteParams)?.reduce((previousValue, currentValue) => {
        return {
            ...previousValue,
            [currentValue]: currentUrlRouteParams?.[currentValue]?.toString()?.split(",") ?? []
        }
    }, {})

    const convertFormValues = (fv = {}) => {
        return {
            ...currentUrlRouteParams,
            ...Object?.keys(fv)?.reduce((previousValue, currentValue) => {
                return {
                    ...previousValue,
                    [currentValue]: (whatIsIt(fv[currentValue]) === "Array" ? fv[currentValue]?.join(",") : fv[currentValue]) ?? ""
                }
            }, {})
        }
    }
    const setFormValues = (newFormValues = {}) => {
        // set navigation params
        navigation.setParams(convertFormValues(newFormValues))
    }

    // ** Filter action
    const onFinishSelecting = (newFormValues = {}) => {

        const newRouteParams = convertFormValues(newFormValues)

        if (newFormValues) {
            props.apiRequest(requestApiService, {id: schoolId}, {}, {
                ...newRouteParams
            })
        } else {
            props.apiRequest(requestApiService, {id: schoolId}, {}, {...newRouteParams})
        }
    }

    const ensureArray = (value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.split(',').filter(Boolean);
        return [];
    };

    const dimensions = useContext(DimensionsContext)

    const startOfWeekDay = 0
    const diff = moment().weekday() - startOfWeekDay
    // console.log("diff", diff)

    const thisWeekText = "Depuis " + ((diff === 1) ? "hier" : (Object.values(weekDaysObject)[startOfWeekDay] ?? "Lundi")?.toLowerCase() + " dernier")

    const periodNames = [
        "Aujourd'hui",
        thisWeekText,
        "La semaine dernière",
        "Depuis le début"
    ]
    const periods = [
        "today",
        "this_week",
        "last_week",
        "lifetime"
    ]

    const [periodIndex, setPeriodIndex] = useState(3)
    const period = periods[periodIndex]

    const renderHeader = () => <View style={{width: "100%", justifyContent: "space-between", flexDirection: "row"}}>
        <View style={{flexDirection: "row", alignItems: "center", marginRight: 20}}>
            <IconButton
                icon={"times"}
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                size={32}
                style={{
                    // position: "absolute",
                    marginRight: 10
                }}
                onPress={() => {
                    if (navigation.canGoBack()) navigation.goBack()
                    else navigation.replace("menu")
                }}
            />
            <IconImageM uri={school?.logo_path} width={40} style={{resizeMode: 'contain', marginRight: 8}}/>
            <TitleM>{school?.name ?? "École"} - Élèves</TitleM>
        </View>
        <View style={{flexDirection: "row", alignItems: "center", alignSelf: "flex-end"}}>
            <SelectInputM options={periods.map((p, i) => ({
                value: p,
                label: periodNames[i]
            }))}
                          noLabel
                // sliderLabel={"Choisir la periode"}
                          value={period}
                          onSelect={(value) => {
                              setPeriodIndex(periods.indexOf(value))
                          }}
                          style={{
                              margin: 5,
                              width: 220
                              // width: (dimensions.width / 2) - 20
                          }}
            />
            <ServerSearch style={{
                width: 240,
                margin: 10
            }}
                          urlParams={formValues}
                          setUrlParams={(newUrlParams) => {
                              setFormValues(newUrlParams)
                              onFinishSelecting(newUrlParams)
                          }}
            />
        </View>
    </View>

    return (
        <View style={{
            flex: 1
        }}
        >
            {props.getUsersStatsRequest ? <ActivityIndicator color={theme.colors.primary}/> : <>
                <HeaderContainerM style={{justifyContent: "space-between", width: "100%"}}>
                    {dimensions?.width < 800 ? <ScrollView horizontal={true} style={{width: "100%"}}>
                        <View style={{flexDirection: "row", width: Dimensions.get("window").width}}>
                            {renderHeader()}
                        </View>
                    </ScrollView> : <>
                        {renderHeader()}
                    </>}
                </HeaderContainerM>
                <SchoolStudentsTable
                    requestApi={schoolsService.searchUser}
                    anonymous={anon}
                    routeParams={{id: schoolId}}
                    urlParams={{...currentUrlRouteParams}}
                    additionalHeader={<SchoolStatisticsHeader school={school} statsPeriod={period}/>}
                    statsPeriod={period}/>
            </>
            }
        </View>
    )


}

const mapStateToProps = state => {
    return {
        schools: state.data.schools?.list
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolScreen)